import React from "react";
import Timeline from "./Timeline";
import profile from "../assets/aboutme/profile.png";

const experience = [
  {
    co: "Company-1",
    years: "2023 — present",
    title: "Senior UX Designer",
    desc: "Leading design across checkout, dashboard, and the design system.",
  },
  {
    co: "Company-2",
    years: "2021 — 2023",
    title: "UX Designer",
    desc: "Led onboarding redesign that lifted activation by 22%. WCAG AA compliance.",
  },
  {
    co: "Company-3",
    years: "2019 — 2021",
    title: "Product Designer",
    desc: "Sole designer. Took product from whiteboard to live in 14 weeks.",
  },
  {
    co: "Company-4",
    years: "2018 — 2019",
    title: "UX Designer",
    desc: "Redesigned analytics dashboard. Built micro-interactions library.",
  },
  {
    co: "Company-5",
    years: "2016 — 2018",
    title: "Junior Designer",
    desc: "Discovery research and hi-fi prototype used to close Series A.",
  },
];

function AboutView() {
  return (
    <div className="about-main">
      <div className="about-inner">
        <div className="about-top">
          <div>
            {/* <div className="about-ey">About me</div> */}
            <div className="about-h">
              Designing systems that
              <br />
              feel effortless.
            </div>
            <div className="about-sub">
              I'm a UX designer currently at the University of Michigan's
              Environment, Health &amp; Safety team, designing digital
              experiences that help thousands of researchers and staff navigate
              safety, training, and organizational knowledge. I care about
              systems that are clear, accessible, and built for real people.
            </div>
            <div className="about-acts">
              <div className="about-act">
                <a
                  className="sb-ext-link"
                  href="/BrannKhattiyanont_Resume.pdf"
                  target="_blank"
                >
                  Resume ↓
                </a>
              </div>
              <div className="about-act">
                <a
                  className="sb-ext-link"
                  style={{ textDecoration: "none", color: "#666" }}
                  href="https://www.linkedin.com/in/bannawit-brann-khattiyanont/"
                >
                  LinkedIn ↗
                </a>
              </div>
              <div className="about-act">bannawit.kh@gmail.com ↗</div>
            </div>
          </div>
          <div className="about-photo">
            <img
              src={profile}
              alt="profile"
              style={{ width: "100%", borderRadius: "4px" }}
            />
          </div>
        </div>

        <div className="about-sec">
          <div className="about-sec-lbl">Skills &amp; tools</div>
          <div className="skill-grid">
            <div className="skill-card">
              <div className="skill-cat">Design</div>
              <div className="skill-items">
                UX / UI
                <br />
                Interaction
                <br />
                Design systems
                <br />
                Prototyping
              </div>
            </div>
            <div className="skill-card">
              <div className="skill-cat">Research</div>
              <div className="skill-items">
                Interviews
                <br />
                Usability testing
                <br />
                Survey design
                <br />
                Synthesis
              </div>
            </div>
            <div className="skill-card">
              <div className="skill-cat">Tools</div>
              <div className="skill-items">
                Figma / FigJam
                <br />
                Adobe Suites
                <br />
                Google Workplace
                <br />
                Coding
              </div>
            </div>
          </div>
        </div>

        {/* <div className="about-sec">
          <div className="about-sec-lbl">Experience</div>
          {experience.map((row) => (
            <div className="exp-row" key={row.co}>
              <div>
                <div className="exp-co">{row.co}</div>
                <div className="exp-years">{row.years}</div>
              </div>
              <div>
                <div className="exp-title">{row.title}</div>
                <div className="exp-desc">{row.desc}</div>
              </div>
            </div>
          ))}
        </div> */}

        <div className="about-sec">
          {/* <div className="about-sec-lbl">Hey, Brann's here!</div> */}
          <div className="about-sec-lbl">Story Time!</div>
          <Timeline />
        </div>

        {/* <div className="about-sec">
          <div className="about-sec-lbl">A bit more</div>
          <div className="about-prose">
            Outside of work I think about information architecture,
            accessibility, and how design systems scale across large
            institutions. I believe the best design feels inevitable — it just
            makes people feel like someone actually understood their problem
            before writing a single line of CSS.
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default AboutView;
